
import { useState } from 'react';

const inquiryTypes = [
  '교회사 강연 의뢰',
  '쇼호스트 섭외',
  'AI 강의 문의',
  '기타'
];

export default function ContactSection() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    inquiryType: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!formData.name || !formData.email || !formData.inquiryType || !formData.message) {
      return;
    }

    if (formData.message.length > 500) return;

    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      formBody.append('name', formData.name);
      formBody.append('email', formData.email);
      formBody.append('inquiryType', formData.inquiryType);
      formBody.append('message', formData.message);

      const response = await fetch('https://readdy.ai/api/form/d6h4u0jlm9ihjki3ej60', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ name: '', email: '', inquiryType: '', message: '' });
      } else {
        setSubmitStatus('error');
      }
    } catch {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="py-16 md:py-24 px-4 md:px-6" style={{ backgroundColor: '#111827' }}>
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10 md:mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-3 md:mb-4">
            문의하기
          </h2>
          <p className="text-base md:text-lg max-w-2xl mx-auto font-medium" style={{ color: 'rgba(255,255,255,0.6)' }}>
            강연, 방송, 강의 문의 및 협업 제안을 환영합니다
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12">
          <div className="rounded-3xl p-6 md:p-8" style={{ backgroundColor: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.1)' }}>
            <form id="contact-form" onSubmit={handleSubmit} data-readdy-form>
              <div className="mb-5 md:mb-6">
                <label htmlFor="name" className="block text-sm font-semibold mb-2" style={{ color: 'rgba(255,255,255,0.8)' }}>
                  이름 <span className="text-red-400">*</span>
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  className="w-full px-4 py-3 rounded-lg focus:outline-none focus:ring-2 transition-all text-sm text-white placeholder-white/30"
                  style={{ backgroundColor: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,255,255,0.15)' }}
                  placeholder="홍길동"
                  required
                />
              </div>

              <div className="mb-5 md:mb-6">
                <label htmlFor="email" className="block text-sm font-semibold mb-2" style={{ color: 'rgba(255,255,255,0.8)' }}>
                  이메일 <span className="text-red-400">*</span>
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  className="w-full px-4 py-3 rounded-lg focus:outline-none focus:ring-2 transition-all text-sm text-white placeholder-white/30"
                  style={{ backgroundColor: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,255,255,0.15)' }}
                  placeholder="example@email.com"
                  required
                />
              </div>

              <div className="mb-5 md:mb-6">
                <label htmlFor="inquiryType" className="block text-sm font-semibold mb-2" style={{ color: 'rgba(255,255,255,0.8)' }}>
                  문의 유형 <span className="text-red-400">*</span>
                </label>
                <select
                  id="inquiryType"
                  name="inquiryType"
                  value={formData.inquiryType}
                  onChange={(e) => setFormData({ ...formData, inquiryType: e.target.value })}
                  className="w-full px-4 py-3 rounded-lg focus:outline-none focus:ring-2 transition-all text-sm cursor-pointer text-white"
                  style={{ backgroundColor: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,255,255,0.15)' }}
                  required
                >
                  <option value="" style={{ backgroundColor: '#1f2937' }}>선택해주세요</option>
                  {inquiryTypes.map((type) => (
                    <option key={type} value={type} style={{ backgroundColor: '#1f2937' }}>{type}</option>
                  ))}
                </select>
              </div>

              <div className="mb-5 md:mb-6">
                <label htmlFor="message" className="block text-sm font-semibold mb-2" style={{ color: 'rgba(255,255,255,0.8)' }}>
                  메시지 <span className="text-red-400">*</span>
                  <span className="text-xs ml-2" style={{ color: 'rgba(255,255,255,0.4)' }}>({formData.message.length}/500자)</span>
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={(e) => {
                    if (e.target.value.length <= 500) {
                      setFormData({ ...formData, message: e.target.value });
                    }
                  }}
                  rows={5}
                  className="w-full px-4 py-3 rounded-lg focus:outline-none focus:ring-2 transition-all resize-none text-sm text-white placeholder-white/30"
                  style={{ backgroundColor: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,255,255,0.15)' }}
                  placeholder="문의 내용을 입력해주세요 (최대 500자)"
                  required
                />
              </div>

              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full px-8 py-4 rounded-full font-semibold text-base md:text-lg hover:shadow-xl transition-all duration-300 hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer text-gray-900"
                style={{ backgroundColor: '#C9F53B' }}
              >
                {isSubmitting ? '전송 중...' : '문의하기'}
              </button>

              {submitStatus === 'success' && (
                <div className="mt-4 p-4 rounded-lg text-sm" style={{ backgroundColor: 'rgba(201,245,59,0.15)', color: '#C9F53B', border: '1px solid rgba(201,245,59,0.3)' }}>
                  문의가 성공적으로 전송되었습니다. 빠른 시일 내에 답변드리겠습니다.
                </div>
              )}
              {submitStatus === 'error' && (
                <div className="mt-4 p-4 rounded-lg text-sm" style={{ backgroundColor: 'rgba(239,68,68,0.15)', color: '#fca5a5', border: '1px solid rgba(239,68,68,0.3)' }}>
                  문의 전송에 실패했습니다. 잠시 후 다시 시도해주세요.
                </div>
              )}
            </form>
          </div>

          <div className="flex flex-col justify-center gap-5 md:gap-6">
            <div className="rounded-3xl p-6 md:p-8" style={{ backgroundColor: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.1)' }}>
              <h3 className="text-xl md:text-2xl font-bold text-white mb-5 md:mb-6">연락처 정보</h3>
              <div className="space-y-5 md:space-y-6">
                <div className="flex items-start gap-4">
                  <div className="w-11 h-11 md:w-12 md:h-12 flex items-center justify-center rounded-full flex-shrink-0" style={{ backgroundColor: 'rgba(201,245,59,0.15)' }}>
                    <i className="ri-mail-line text-xl md:text-2xl" style={{ color: '#C9F53B' }}></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-white mb-1 text-sm md:text-base">이메일</h4>
                    <p className="text-sm md:text-base" style={{ color: 'rgba(255,255,255,0.55)' }}>contact@euhjunghee.com</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-11 h-11 md:w-12 md:h-12 flex items-center justify-center rounded-full flex-shrink-0" style={{ backgroundColor: 'rgba(201,245,59,0.15)' }}>
                    <i className="ri-building-line text-xl md:text-2xl" style={{ color: '#C9F53B' }}></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-white mb-1 text-sm md:text-base">소속</h4>
                    <p className="text-sm md:text-base" style={{ color: 'rgba(255,255,255,0.55)' }}>사람아이앤지</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="rounded-3xl p-6 md:p-8" style={{ backgroundColor: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.1)' }}>
              <h3 className="text-xl md:text-2xl font-bold text-white mb-5 md:mb-6">SNS</h3>
              <div className="flex gap-4">
                <a href="#" className="w-11 h-11 md:w-12 md:h-12 flex items-center justify-center rounded-full hover:scale-110 transition-all duration-300 cursor-pointer" style={{ backgroundColor: 'rgba(255,255,255,0.1)' }} aria-label="Instagram">
                  <i className="ri-instagram-line text-xl md:text-2xl text-white"></i>
                </a>
                <a href="#" className="w-11 h-11 md:w-12 md:h-12 flex items-center justify-center rounded-full hover:scale-110 transition-all duration-300 cursor-pointer" style={{ backgroundColor: 'rgba(255,255,255,0.1)' }} aria-label="YouTube">
                  <i className="ri-youtube-line text-xl md:text-2xl text-white"></i>
                </a>
                <a href="#" className="w-11 h-11 md:w-12 md:h-12 flex items-center justify-center rounded-full hover:scale-110 transition-all duration-300 cursor-pointer" style={{ backgroundColor: 'rgba(255,255,255,0.1)' }} aria-label="Blog">
                  <i className="ri-article-line text-xl md:text-2xl text-white"></i>
                </a>
              </div>
            </div>

            {/* CTA 배너 */}
            <div className="rounded-3xl p-6 md:p-8 text-center" style={{ backgroundColor: '#C9F53B' }}>
              <p className="text-2xl font-extrabold text-gray-900 mb-2">함께 만들어가요</p>
              <p className="text-sm text-gray-700 mb-4">강연·방송·교육 협업 제안 환영합니다</p>
              <div className="flex items-center justify-center gap-2">
                <span className="w-2 h-2 rounded-full bg-gray-900 animate-pulse"></span>
                <span className="text-sm font-bold text-gray-900">현재 섭외 가능</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
